import { NumberFormatOptions, NumberFormats } from "vue-i18n"

export type NumberFormatNames = 'currency' | 'percent'

type GMSNumberFormat = { [K in NumberFormatNames]: NumberFormatOptions }

const en: GMSNumberFormat = {
    currency: {
        style: 'currency',
        currency: 'EUR',
        notation: 'standard',
        currencyDisplay: 'symbol',
    },
    percent: {
        style: 'percent',
        useGrouping: false,
    },
}

const de: GMSNumberFormat = {
    currency: {
      style: 'currency',
      currency: 'EUR',
      notation: 'standard',
      currencyDisplay: 'symbol',
    },
    percent: {
      style: 'percent',
      useGrouping: false,
    },
}

const it: GMSNumberFormat = {
    currency: {
      style: 'currency',
      currency: 'EUR',
      notation: 'standard',
      currencyDisplay: 'symbol',
    },
    percent: {
      style: 'percent',
      useGrouping: false,
    },
}

const fr: GMSNumberFormat = {
    currency: {
      style: 'currency',
      currency: 'EUR',
      notation: 'standard',
      currencyDisplay: 'symbol',
    },
    percent: {
      style: 'percent',
      useGrouping: false,
    },
}

export const defaultNumberFormats: NumberFormats = {
    en,
    de,
    it,
    fr,
}